import React from 'react'

const Signature = () => (
  <>
    Made with React and a lot of <span>&#10084;</span> by{' '}
    <a
      href="https://www.linkedin.com/in/lcpalves/"
      target="_blank"
      rel="noreferrer"
    >
      Luiz C
    </a>
    . <br />
    Access the{' '}
    <a
      href="https://github.com/luizpinheiro/react-minesweeper/"
      target="_blank"
      rel="noreferrer"
    >
      project&apos;s github
    </a>{' '}
    to see the code.
  </>
)

export default React.memo(Signature)
